export default __webpack_public_path__ + "static/media/why-keyes-2-safety-banner.257c916a.png";